// extracted by mini-css-extract-plugin
export var container = "_t5-0";
export var table = "_t5-2";
export var tableWrapper = "_t5-1";